const DEFAULT_FACET_NAME = 'base';
const BEM_MODIFIER_MARKER = '__';
const BEM_ELEMENT_MARKER = '--';


export default function bemMixin(bemRoot) {
    return {
        props: {
            facet: {
                type: String,
                default: DEFAULT_FACET_NAME,
            },
        },
        computed: {
            bemRoot() {
                return `${ bemRoot }`;
            },
            bemFacet() {
                // NOTE: As `facet` can still be an empty string, we'll provide a base facet as a fallback
                return this.bemAdd(this.facet || DEFAULT_FACET_NAME);
            },
        },
        methods: {
            bemAdd(modifierName, elementName) {
                const elementPart = elementName ? `${ BEM_ELEMENT_MARKER }${ elementName }` : '';
                const modifierPart = modifierName ? `${ BEM_MODIFIER_MARKER }${ modifierName }` : '';
                return modifierPart ? `${ this.bemRoot }${ elementPart }${ modifierPart }` : '';
            },
            bemIf(condition, trueModifier, falseModifier) {
                return this.bemAdd(condition ? trueModifier : falseModifier);
            },
        },
    };
};



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/vue/mixins/bem/index.js